<template>
  <div>
    <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="onClose" :appendToBody="true"
            style="z-index: 123123" :pxFromTop="isSupplements ? 1 : 2"
            :isCloseOnEsc="!isCreateCategory && !theEditTask && !isWatchGuide">
      <div class="d-modal" :class="{'d-modal__supplements': isSupplements}" slot="insertComponent">
        <div class="d-modal__header d-modal__header__supplements" v-if="isSupplements">
          <h3>Tilføj tillægstyper</h3>
          <div class="font-large icon__bg-circle" @click="onClose"><span
            class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content text-dark">
          <div class="d-modal__content__sidebar" v-if="!isSupplements">
            <div class="font-large icon__bg-circle d-modal__header__close" @click="onClose"><span
              class="icon-cross2"></span>
            </div>
            <h2>Design opgaveoversigter</h2>
            <ul class="d-modal__content__sidebar__nav">
              <button class="do-bttn" id="do-bttn--watch-guide" @click="isWatchGuide = true">Se guide</button>
              <li v-for="tab in tabs"
                  class="d-modal__content__sidebar__nav-item"
                  :class="{'d-modal__content__sidebar__nav-item--active': tab.id === theActiveTab}"
                  @click="setTheActiveTab(tab.id)">
                {{ tab.title }}
              </li>
            </ul>
          </div>
          <div class="d-modal__content__body">
            <Loader v-if="isInitLoading" bgColor="#fff"></Loader>
            <template v-else>
              <TaskOverviewSettingsCategories
                v-if="theActiveTab === 1"
                :schoolId="schoolId"
                :schoolYearId="schoolYearId"
                :schoolYear="schoolYear"
                :locale="locale"
                :taskCategories="taskCategories"
                :dbSubjectTypes="dbSubjectTypes"
                :subjects="subjects"
                @onDeleteTaskCategory="onDeleteTaskCategory"
                @updateCategory="onUpdateCategory"
                @setCreateCategory="setCreateCategory"
                @onSetEditTask="onSetEditTask"
              >
              </TaskOverviewSettingsCategories>
              <TaskOverviewSettingsCategoriesTasks
                v-if="theActiveTab === 2"
                :taskCategories="taskCategoriesSorted"
                :schoolId="schoolId"
                :schoolYearId="schoolYearId"
                :subjects="subjects"
                :allCalendarsInHash="allCalendarsInHash"
                :allUsersInHash="allUsersInHash"
                :tags="tags"
                :isSupplements="isSupplements"
                :supplementTypes="supplementTypes"
                @setCreateCategory="setCreateCategory"
                @updateSubjects="updateSubjects">
              </TaskOverviewSettingsCategoriesTasks>
              <TaskOverviewSettingsSettings
                :taskCategories="taskCategories"
                v-if="theActiveTab === 3">
              </TaskOverviewSettingsSettings>
              <TaskOverviewSettingsUserTasks
                v-if="theActiveTab === 4"
                :theActiveUserId="theActiveUserIdForExample"
                :users="users"
                :schoolYear="schoolYear"
                @setTheActiveUserId="setTheActiveUserIdForExample">
              </TaskOverviewSettingsUserTasks>
            </template>
          </div>
          <TaskOverviewSettingsCategoryCreate
            v-if="isCreateCategory"
            :schoolId="schoolId"
            :schoolYearId="schoolYearId"
            :taskCategories="taskCategories"
            @close="isCreateCategory = false"
            @onNewCategory="onNewCategory">
          </TaskOverviewSettingsCategoryCreate>
        </div>
      </div>
    </DModal>
    <DModal v-if="isWatchGuide" :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="isWatchGuide = false"
            :appendToBody="true"
            style="z-index: 12312323" :isCloseOnEsc="!isCreateCategory && !theEditTask">
      <div class="d-modal d-modal--guide" style="width: 90vw" slot="insertComponent">
        <div class="font-large icon__bg-circle d-modal__header__close" @click="isWatchGuide = false"><span
          class="icon-cross2"></span>
        </div>
        <div class="d-modal__content__guide text-dark">
          <TaskOverviewSettingsGuide></TaskOverviewSettingsGuide>
        </div>
      </div>
    </DModal>
  </div>
</template>
<script>
import DModal from '../common/DModal.vue'
import Loader from '../common/Loader.vue'
import TaskOverviewSettingsCategoriesTasks from './TaskOverviewSettingsCategoriesTasks.vue'
import docendo from '../../docendo'
import TaskOverviewSettingsCategories from './TaskOverviewSettingsCategories.vue'
import TaskOverviewSettingsCategoryCreate from './TaskOverviewSettingsCategoriesCreate.vue'
import TaskOverviewSettingsUserTasks from './TaskOverviewSettingsUserTasks.vue'
import TaskOverviewSettingsGuide from './TaskOverviewSettingsGuide.vue'
import TaskOverviewSettingsSettings from './TaskOverviewSettingsSettings.vue'

export default {
  components: {
    TaskOverviewSettingsGuide,
    TaskOverviewSettingsUserTasks,
    TaskOverviewSettingsCategories,
    TaskOverviewSettingsCategoryCreate,
    TaskOverviewSettingsSettings,
    Loader,
    DModal,
    TaskOverviewSettingsCategoriesTasks
  },
  props: {
    isSupplements: {
      type: Boolean,
      default: false
    },
    supplementTypes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isWatchGuide: false,
      tabs: [
        {id: 1, title: '1. Opret og organiser kategorier'},
        {id: 2, title: '2. Tilpas kategorier til brikker'},
        {id: 3, title: '3. Lav yderligere indstillinger'},
        {id: 4, title: '4. Se opgaveoversigter'}
      ],
      theActiveTab: 1,
      isLoadingSubjects: true,
      subjects: [],
      taskCategories: [],
      isLoadingTaskCategories: true,
      isCreateCategory: false,
      theEditTask: null,
      theActiveUserIdForExample: null,
      tags: []
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    locale () {
      return this.$store.getters.locale
    },
    dbSubjectTypes () {
      return this.$store.state.subjects.dbSubjectTypes
    },
    isInitLoading () {
      return this.isLoadingSubjects || this.isLoadingTaskCategories
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    taskCategoriesSorted () {
      return this.taskCategories.sort((a, b) => a.rank - b.rank)
    }
  },
  watch: {
    schoolYearId (val) {
      this.readSubjects()
      this.readTaskCategories()
    }
  },
  methods: {
    setTheActiveUserIdForExample (val) {
      this.theActiveUserIdForExample = val
    },
    onSetEditTask (evt) {
      this.theEditTask = evt
    },
    updateSubjects (updates) {
      updates.forEach(subjectUpdate => {
        const idx = this.subjects.findIndex(subject => subject.id === subjectUpdate.id)
        if (idx !== -1) {
          if (this.isSupplements) {
            this.$set(this.subjects, idx, {
              ...this.subjects[idx],
              salary_supplement_type_id: subjectUpdate.salary_supplement_type_id
            })
          } else {
            this.$set(this.subjects, idx, {
              ...this.subjects[idx],
              selected_task_category_id: subjectUpdate.selected_task_category_id
            })
          }
        }
      })
    },
    onNewCategory (theNewCategory) {
      this.taskCategories.push(theNewCategory)
      this.isCreateCategory = false
    },
    onDeleteTaskCategory (theDeletedCategoryId) {
      const idx = this.taskCategories.findIndex(cat => cat.id === theDeletedCategoryId)
      this.taskCategories.splice(idx, 1)
    },
    onUpdateCategory (theUpdatedCategory) {
      const idx = this.taskCategories.findIndex(cat => cat.id === theUpdatedCategory.id)
      this.$set(this.taskCategories, idx, theUpdatedCategory)
    },
    setCreateCategory (bool) {
      this.isCreateCategory = bool
    },
    onClose () {
      this.$emit('close')
    },
    setTheActiveTab (tabId) {
      this.theActiveTab = tabId
    },
    readSubjects () {
      this.isLoadingSubjects = true
      docendo.readSubjectCalendars(this.schoolId, this.schoolYearId, data => {
        this.isLoadingSubjects = false
        this.subjects = data
      }, failure => {
        console.log('failed read subjects')
      })
    },
    readTaskCategories () {
      this.isLoadingTaskCategories = true
      docendo.readTaskCategories(this.schoolId, this.schoolYearId, data => {
        this.isLoadingTaskCategories = false
        this.taskCategories = data && data.length > 0 ? data : []
      })
    },
    readTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    }
  },
  beforeMount () {
    if (this.isSupplements) {
      this.theActiveTab = 2
    }
  },
  mounted () {
    if (this.schoolYearId && this.schoolId) {
      this.readSubjects()
      this.readTaskCategories()
      this.readTags()
    }
  }
}
</script>
<style scoped>
@import "../../assets/css/variables.css";

.d-modal {
  width: calc(100vw - 2rem);
  border-radius: 16px;
  position: relative;
}

.d-modal__content {
  padding: 0;
  display: flex;
}

.d-modal__content__sidebar {
  padding: 0 0 4rem;
  border-right: 1px solid #e2e8f0;
}

.d-modal__content__body {
  padding: 0rem 0 0 1rem;
  border-radius: 0 4px 0 0;
  background: #fff;
  position: relative;
  flex: 1;
  min-height: 90vh;
  max-height: calc(100vh - 3rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.d-modal__header__close {
  position: absolute;
  top: 0rem;
  left: 0rem;
}

.d-modal__content__sidebar h2 {
  padding: 3rem 2rem 2rem 2rem;
  line-height: 1rem;
}

.d-modal__content__sidebar__nav-item {
  min-width: 200px;
  width: 100%;
  padding: 1rem 2rem;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid transparent;
  border-width: 1px 0 1px 1px;
}

.d-modal__content__sidebar__nav-item--active {
  background-color: #fff;
  border-color: #468ad7;
  font-weight: 700;
  color: #468ad7;
  border-color: #e2e8f0;
}

#do-bttn--watch-guide {
  width: calc(100% - 4rem);
  margin: 0rem 2rem 1rem 2rem;
}

.d-modal__content__guide {
  margin: 0 auto;
}

.d-modal--guide {
  width: 80vw;
  position: relative;
}

.d-modal__header__supplements {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px
}

</style>



// WEBPACK FOOTER //
// TaskOverviewSettings.vue?00a3abca